// @flow
import React, { useEffect } from 'react';

const TARGET_URL = 'https://paidy.com/merchant/application/#documents';

const IndexPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.location.href = TARGET_URL;
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      <a href={TARGET_URL}>
        ページが自動的にリダイレクトされない場合は、こちらをクリックしてください。
      </a>
    </div>
  );
};

export default IndexPage;
